import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { fetchImages } from './duck'
import { apiImageUrl } from 'lib/utils'

import './style.scss'

export class HeaderImage extends PureComponent {
  componentWillMount() {
    const {
      images,
      loading
    } = this.props

    if (!loading && !images)
      this.props.dispatch(fetchImages())
  }

  render() {
    const {
      images
    } = this.props

    return (
      <div className="headerImage">
        {images ? <img src={apiImageUrl('WebImage', images[0].Id)} alt="Insperation Pressrum" /> : null}
      </div>
    )
  }
}


const mapStateToProps = state => ({
  images: state.pressroom.headerimage.images,
  loading: state.pressroom.headerimage.loading
})
export default connect(mapStateToProps)(HeaderImage)